import { UserDto } from "../dto/user.dto";
import axios from "../utils/axios";
import { ApiInterface } from "./api.interface";

class UsersApi extends ApiInterface {
  constructor() {
    super("users");
  }

  public async getInfo(): Promise<UserDto> {
    return await axios.get(`${this.rootEndpoint}/info`);
  }
}

export const usersApi = new UsersApi();
